define('views/modules/template/assignment/list/per-template/assignment-list-item',[
    // Libs
    'underscore', 'backbone', 'mustache', 'bootbox', 'utils',
    // services
    'services/i18n',
    // views
    'views/parts/media-info-box',
    'views/modules/template/assignment/list/per-user/per-user-assignment-list-item',
    // templates
    'text!templates/modules/template/assignment/list/assignment-list-item-content.html'
], function(
    // Libs
    _, Backbone, Mustache, Bootbox, U,
    // services
    i18n,
    // views
    VMediaInfoBox,
    VPerUserAssignmentListItem,
    // templates
    TAssignmentListItemContent
) {

    var VAssignmentListItem = VPerUserAssignmentListItem.extend({
        className: 'assignment-list-item',

        regions: {
            menu: ".menu-options",
        },

        initialize: function(opt) {
            this.options = opt || {};

            var model = this.model,
                view = this.view = {
                    infobox: new VMediaInfoBox({
                        title: 'userDisplayName',
                        model: model,
                        context: this,
                        extraContent: TAssignmentListItemContent,
                        onClick: this.onClick,
                        menu: {
                            init: this.onMenuInit,
                            onClick: this.onActionClick,
                        }
                    }),
                };

            this.listenTo(model, { 'remove': this.remove });
        },

        setActive: function(val) {
            this.$el.toggleClass('active', val);
        },

        isActive: function() {
            return this.$el.hasClass('active');
        },

        onClick: function(e) {
            if (!this.$(e.target).hasClass('options-toggle')) {
                this.setActive();
            }
            this.model.trigger('assignment:click', this.model, this.isActive());
        },

    });

    return VAssignmentListItem;

});

